import React from 'react';

const Colours = [
    { name: "White", code: "1001", hex: "#ffffff" },
    { name: "Cream", code: "1005", hex: "#efeadf" },
    { name: "Parchment", code: "1218", hex: "#d5c7ba" },
    { name: "Stone", code: "1710", hex: "#e4bf99" },
    { name: "Toy", code: "1844", hex: "#dcae8d" },
    { name: "Buttermilk", code: "1835", hex: "#ecce9e" },
    { name: "Copper", code: "1029", hex: "#8b3822" },
    { name: "Walnut", code: "1054", hex: "#52382d" },
    { name: "Mocha", code: "1064", hex: "#8f7364" },
    { name: "Gingerbread", code: "1806", hex: "#9c582a" },
    { name: "Dark Brown", code: "1004", hex: "#35251f" },
    { name: "Plum", code: "1061", hex: "#672b51" },
    { name: "Magenta", code: "1084", hex: "#a04c96" },
    { name: "Emperor", code: "1425", hex: "#311836" },
    { name: "Grape", code: "1067", hex: "#734b61" },
    { name: "Lavender", code: "1188", hex: "#7d81b7" },
    { name: "Violet", code: "1277", hex: "#5c4677" },
    { name: "Wisteria", code: "1432", hex: "#9f95c9" },
    { name: "Parma Violet", code: "1724", hex: "#d0c2d1" },
    { name: "Boysenberry", code: "1828", hex: "#8d2a63" },
    { name: "Proper Purple", code: "1855", hex: "#4e3172" },
    { name: "Royal", code: "1117", hex: "#18276a" },
    { name: "Duck Egg", code: "1820", hex: "#c6d2d4" },
    { name: "Empire", code: "1829", hex: "#0c5e78" },
    { name: "Aster", code: "1003", hex: "#2d6caa" },
    { name: "Midnight", code: "1011", hex: "#1e1d27" },
    { name: "Cloud Blue", code: "1019", hex: "#88add2" },
    { name: "Sherbet", code: "1034", hex: "#9bcbd7" },
    { name: "Teal", code: "1062", hex: "#3a7f80" },
    { name: "Turquoise", code: "1068", hex: "#3e94bd" },
    { name: "Bluebell", code: "1082", hex: "#566db9" },
    { name: "Denim", code: "1302", hex: "#4b6392" },
    { name: "Aspen", code: "1422", hex: "#4eb3b6" },
    { name: "Petrol", code: "1708", hex: "#346f84" },
    { name: "Storm Blue", code: "1722", hex: "#72939e" },
    { name: "Lobelia", code: "1825", hex: "#473a8e" },
    { name: "Cornish Blue", code: "1841", hex: "#2f6b8f" },
    { name: "Lapis", code: "1831", hex: "#33438d" },
    { name: "Candyfloss", code: "1130", hex: "#f7c8d5" },
    { name: "Fondant", code: "1241", hex: "#e386a6" },
    { name: "Fiesta", code: "1257", hex: "#f0428f" },
    { name: "Fuchsia Purple", code: "1827", hex: "#c93175" },
    { name: "Powder Pink", code: "1843", hex: "#d4a5b8" },
    { name: "Raspberry", code: "1023", hex: "#8b2440" },
    { name: "Apricot", code: "1026", hex: "#f4baa9" },
    { name: "Pale Rose", code: "1080", hex: "#b4818f" },
    { name: "Pomegranate", code: "1083", hex: "#990537" },
    { name: "Soft Peach", code: "1240", hex: "#e5d3d8" },
    { name: "Clematis", code: "1390", hex: "#cba6c5" },
    { name: "Bright Pink", code: "1435", hex: "#b50743" },
    { name: "Blush", code: "1833", hex: "#f4949c" },
    { name: "Kelly Green", code: "1826", hex: "#0a562e" },
    { name: "Bottle", code: "1009", hex: "#071f15" },
    { name: "Khaki", code: "1027", hex: "#544e35" },
    { name: "Meadow", code: "1065", hex: "#838755" },
    { name: "Green", code: "1116", hex: "#076e37" },
    { name: "Bright Green", code: "1259", hex: "#79dc96" },
    { name: "Spring Green", code: "1316", hex: "#b5daba" },
    { name: "Lime", code: "1712", hex: "#a9983a" },
    { name: "Sage", code: "1725", hex: "#4e796a" },
    { name: "Grass Green", code: "1821", hex: "#89cd5d" },
    { name: "Cypress", code: "1824", hex: "#88a282" },
    { name: "Spearmint", code: "1842", hex: "#6daca8" },
    { name: "Apple", code: "1852", hex: "#9fb51f" },
    { name: "Lincoln", code: "1834", hex: "#98ab97" },
    { name: "Black", code: "1002", hex: "#1e1b1a" },
    { name: "Matador", code: "1010", hex: "#e02930" },
    { name: "Claret", code: "1123", hex: "#4a020e" },
    { name: "Lipstick", code: "1246", hex: "#9c1b29" },
    { name: "Tomato", code: "1723", hex: "#a2211e" },
    { name: "Lemon", code: "1020", hex: "#ece3b9" },
    { name: "Saffron", code: "1081", hex: "#f3af68" },
    { name: "Sunshine", code: "1114", hex: "#fca917" },
    { name: "Citron", code: "1263", hex: "#f2cb6a" },
    { name: "Pistachio", code: "1822", hex: "#d4c979" },
    { name: "Mustard", code: "1823", hex: "#e6ad23" },
    { name: "Dandelion", code: "1856", hex: "#e8a123" },
    { name: "Graphite", code: "1063", hex: "#4c4a4d" },
    { name: "Grey", code: "1099", hex: "#6b6c74" },
    { name: "Silver", code: "1203", hex: "#a0a3ad" },
    { name: "A Hint of Silver", code: "1807", hex: "#e9e5e4" },
    { name: "Warm Grey", code: "1805", hex: "#beb7ad" },
    { name: "Shrimp", code: "1132", hex: "#ea6766" },
    { name: "Jaffa", code: "1256", hex: "#fa6e36" },
    { name: "Spice", code: "1711", hex: "#e65220" },
    { name: "Clementine", code: "1853", hex: "#f88938" },
    { name: "Mushroom", code: "1832", hex: "#c6acb0" },
    { name: "Gold", code: "1709", hex: "#c5853b" },
    { name: "Burgundy", code: "1035", hex: "#350610" },
    { name: "French Navy", code: "1854", hex: "#1a2356" },
    { name: "Camel", code: "1420", hex: "#bd8956" }
];

export default Colours;